// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"164":"c05ccbd7","214":"a392ff8b","254":"a4f46c4c","453":"37d89dc5","721":"d964af8b","833":"cef1363a","976":"cef1363a"}[chunkId] + ".chunk.js";
};